module.exports = __webpack_public_path__ + "media/images/logo-dark-c6b799856d9ee21229beb5ea0246b94f.png";